import classNames from 'classnames';
import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {Strand} from 'constants/MolbioConstants';
import {modelToDisplay, modelEndToDisplay} from 'molbio/SeqUtil';
import {ElementMouseEvent} from 'util/Types';

const STRAND_TO_COPY: Record<Strand, string> = {
  1: 'FWD',
  [-1]: 'REV',
  0: '',
};

export interface FeatureResultProps {
  start: number;
  end: number;
  sequenceStartIndex: number;
  sequenceLength: number;
  name: string;
  nameMatchStart: number;
  nameMatchEnd: number;
  backgroundColor: string;
  backgroundColorStriped: boolean;
  strand: Strand;
  onClick: (e: ElementMouseEvent) => void;
}

function FeatureResultItem({
  end,
  name,
  start,
  strand,
  onClick,
  backgroundColor,
  backgroundColorStriped,
  nameMatchStart,
  nameMatchEnd,
  sequenceStartIndex,
  sequenceLength,
}: FeatureResultProps): JSX.Element {
  return (
    <li className="feature-result">
      <a href="#" onClick={onClick}>
        <div
          className={classNames('feat-swatch pull-left', {striped: backgroundColorStriped})}
          style={{backgroundColor}}
        >
          {STRAND_TO_COPY[strand]}
        </div>
        <div className="text">
          <span className="location pull-right">
            <span className="start">{modelToDisplay(start, sequenceStartIndex)}</span>
            <span>-</span>
            <span className="end">{modelEndToDisplay(end, sequenceLength, sequenceStartIndex)}</span>
          </span>
          <div className="name">
            <span>{name.slice(0, nameMatchStart)}</span>
            <span className="match">{name.slice(nameMatchStart, nameMatchEnd)}</span>
            <span>{name.slice(nameMatchEnd)}</span>
          </div>
        </div>
      </a>
    </li>
  );
}

interface FeatureResultsListProps {
  featuresCapped: boolean;
  featureResults: Array<FeatureResultProps & {id: string}>;
}

export default function FeatureResultsList({
  featuresCapped,
  featureResults,
}: FeatureResultsListProps): JSX.Element {
  return (
    <>
      <li className="result-msg">
        <span className="result-count">
          {featureResults.length}
          {featuresCapped && '+'} feature {pluralize(featureResults.length, 'result')}
        </span>
        {featuresCapped && <span className="result-info">Refine search to see all results</span>}
      </li>
      {featureResults.map(({id, ...featureResultItemProps}) => (
        <FeatureResultItem key={id} {...featureResultItemProps} />
      ))}
    </>
  );
}
